// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lessonPlayerContainer[data-v-f5178190]{display:flex;flex-direction:column}.btnCustom[data-v-f5178190]{font-size:13px;font-weight:500;letter-spacing:1.2px;text-transform:uppercase;width:100%}.active-panel[data-v-f5178190]{background-color:rgba(153,227,187,.5)}.lesson-card-content[data-v-f5178190]{padding:0 7px}.lesson-type[data-v-f5178190]{display:inline-block;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
